<template>
  <div class="chat-widget-container"></div>
  <!-- Tawk.to 自带浮动按钮与窗口，无需额外 UI -->
</template>

<script>
import tawktoService from '@/services/tawktoService'

export default {
  name: 'ChatWidget',
  props: {
    tawktoConfig: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      status: 'loading' // loading | ready | error
    }
  },
  mounted() {
    try {
      tawktoService.init(this.tawktoConfig)
      // 简单轮询确认加载状态
      const check = () => {
        const s = tawktoService.getStatus()
        if (s === 'ready') {
          this.status = 'ready'
        } else {
          setTimeout(check, 300)
        }
      }
      check()
    } catch (e) {
      console.error('初始化 Tawk.to 失败:', e)
      this.status = 'error'
    }
  }
}
</script>

<style scoped>
.chat-widget-container {
  position: relative;
}
</style>